import { render, staticRenderFns } from "./RestaurantOrderShowDetail.vue?vue&type=template&id=4ca4f106&"
import script from "./RestaurantOrderShowDetail.vue?vue&type=script&lang=js&"
export * from "./RestaurantOrderShowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports